import React from 'react';
import styled from 'styled-components';

export const CreateNewQuestion = () => {
  return <Container>Create New Question </Container>;
};

const Container = styled.div`
  width: 100%;
`;
